import { DatePeriod } from "@greeter/date";

export const QueryKey = {
  orders: "orders",
};
const dateFormatter = Intl.DateTimeFormat("da-DK", {
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  month: "numeric",
  year: "numeric",
  day: "numeric",
});

export const bookingKeys = {
  all: (period: DatePeriod) => [
    "bookings",
    dateFormatter.format(period.from),
    dateFormatter.format(period.to),
  ],
  detail: (id: string) => ["bookings", id],
};

// Best practice proposed by https://tkdodo.eu/blog/effective-react-query-keys
export const greeterEventKeys = {
  detail: (id: string) => ["greeterEvents", id],
  forPeriod: (period: DatePeriod) => ["greeterEvents", period],
  all: () =>
    greeterEventKeys.forPeriod(
      new DatePeriod({ from: new Date(), to: new Date(Number.MAX_VALUE) })
    ),
};

export const bundleKeys = {
  all() {
    return ["bundles"];
  },
  detail(id: string) {
    return [...bundleKeys.all(), id];
  },
};

export const productKeys = {
  all: () => ["products"],
  detail: (id: string) => [...productKeys.all(), id],
};

export const themesKeys = {
  all: (venueId?: string) => ["themes"],
};

export const venueKeys = {
  self: () => ["venue"],
  edit: () => ["venue-edit"],
};

export const stripeKeys = {};

export const bookedTablesKeys = {
  forDate: (date: Date) => ["bookedTables", date],
  forDatePeriod: (period: DatePeriod) => ["bookTables", period.from, period.to],
};

export const lockedTablesKeys = {
  forDate: (date: Date) => ["lockedTables", date],
  forDatePeriod: (period: DatePeriod) => [
    "lockedTables",
    period.from,
    period.to,
  ],
};

export const floorPlanKeys = {
  all: () => ["floorPlan"],
  venue: (venueId: string) => ["floorPlan", venueId],
};

export const tableServiceOrderKeys = {
  period: (period: DatePeriod) => ["tableServiceOrder", period],
};

export const tableServiceSettingKeys = {
  self: () => ["tableServiceSettings"],
};

export const customerKeys = {
  detail: (customerId?: string) => ["customer", customerId],
};
